import * as React from "react";

export class SingleEntryControl extends React.Component<SingleEntryControlProps, SingleEntryControlState> {
    static defaultProps: Partial<SingleEntryControlProps> = {};

    constructor(props: SingleEntryControlProps) {
        super(props);
        this.state = {};
    }

    public render() {
        debugger;
        return (
            <div className={'rednao'}>
                <table className={'rntable-striped rntable singleentry'}>
                    <tbody>
                        <tr><th style={{textAlign:'left'}}>Date</th></tr>
                        <tr><td>{this.props.Entry._Date}</td></tr>
                        {this.props.Entry._UserName!=''?
                            <React.Fragment>
                                <tr><th style={{textAlign:'left'}}>Created By</th></tr>
                                <tr><td>{this.props.Entry._UserName}</td></tr>
                            </React.Fragment>:null
                        }
                        {this.GetPropertyRows()}
                        {this.props.SelectedColumns!=null&&this.props.SelectedColumns.find(x=>x.Id=='_Ip')._Selected&&
                            <React.Fragment>
                                <tr><th style={{textAlign:'left'}}>Ip</th></tr>
                                <tr><td>{this.props.Entry._Ip}</td></tr>
                            </React.Fragment>

                        }
                    </tbody>
                </table>
            </div>
        )
    }

    private GetPropertyRows() {
        let fields=[];
        for(let propertyName in this.props.Entry)
        {
            if(propertyName.startsWith('_'))
                continue;

            if(this.props.Entry[propertyName]=='')
                continue;


            let options=this.props.ElementOptions.find(x=>x.Id==propertyName);
            if(options==null)
                continue;


            fields.push(
                <React.Fragment key={propertyName}>
                    <tr><th style={{textAlign:'left'}}>{options.Label}</th></tr>
                    <tr><td dangerouslySetInnerHTML={{__html:this.props.Entry[propertyName]}}/></tr>
                </React.Fragment>
            )
        }

        return fields;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SingleEntryControlProps {
    Entry:any;
    ElementOptions:any;
    SelectedColumns:any[];
}

interface SingleEntryControlState {

}

//#endregion "My Region"